import React from "react";
import MuiDialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/styles";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import "./ProductAssignmentHintDialog.css";

const Dialog = withStyles({
  paper: {
    maxWidth: 480,
    width: "100%",
    borderRadius: 14,
  },
})(MuiDialog);

// Shown when the Credits page opens: credits/products should be given through
// the Ürün Atama panel first. Ürün Atama is the primary (first) option; staying
// on Credits is the secondary one. No onClose on purpose: backdrop/Escape don't
// dismiss it, the admin has to pick one.
export default function ProductAssignmentHintDialog({
  open,
  onGoToProductAssignment,
  onContinue,
}) {
  return (
    <Dialog open={open}>
      <div className="pa-hint">
        <h3 className="pa-hint-title">Önce Ürün Atama Panelini Kullanın</h3>
        <p className="pa-hint-message">
          Kullanıcılara kredi veya ürün tanımlama işlemlerini Ürün Atama
          panelinden yapabilirsiniz. Kredi paneli yalnızca Ürün Atama
          panelinde yapılamayan işlemler için kullanılmalıdır.
        </p>

        <button
          type="button"
          className="pa-hint-primary"
          onClick={onGoToProductAssignment}
        >
          <span className="pa-hint-primary-text">
            <span className="pa-hint-primary-label">Ürün Atama Paneline Git</span>
            <span className="pa-hint-primary-sub">
              Kredi ve ürün tanımlama için önerilen panel
            </span>
          </span>
          <ArrowForwardIcon className="pa-hint-primary-icon" />
        </button>

        <button type="button" className="pa-hint-secondary" onClick={onContinue}>
          Kredi Paneline Devam Et
        </button>
      </div>
    </Dialog>
  );
}
